import { rpc } from "#rpc";
import { SearchModal } from "./SearchModal";
export const SearchModalLoader = async ({}: { locale: string }) => {
  const blok = await rpc.bloks.getSearchModalProducts();
  const links = await rpc.bloks.getSearchCategoryList();

  return <SearchModal categoryStories={links} title={blok?.title} />;
};
